"use client";
import React from "react";
import { FooterNavItem } from "@packages/lib/types/interfaces";
import { usePathname } from "next/navigation";
import { includeTickerTape } from "@packages/lib/utlils/helper-function";
interface PropsInterface {
  data: FooterNavItem;
}
const FooterCopyRights = ({ data }: PropsInterface) => {
  const pathname = usePathname();

  const addPadding = pathname?.includes("search") || pathname?.includes("csearch");
  const spaceingClass = addPadding ? `mb-[70px] lg:mb-0` : (includeTickerTape() ? `mb-[42px]` : "");
  return (
    <>
      {data.navTitle && (
        <div
          className={`copyrights mt-[40px] ${spaceingClass}`}
        >
          <p
            className="x-small text-grey300 text-center"
            data-testid="copy_rights"
          >
            {data.navTitle}
          </p>
        </div>
      )}
    </>
  );
};

export default FooterCopyRights;
